document.addEventListener('product:added', e => {
  console.log('[debug] product:added reached document', e.detail);
});
document.body && document.body.addEventListener('product:added', e => {
  console.log('[debug] product:added reached body', e.detail);
});


const personaliserAddToCart = async (variantId, properties) => {
  await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      properties
    })
  });
};

const getPersonaliserVariantId = (medium, baseSize) => {
  return window.ShopifyAnalytics.meta.product.variants
    .find(v => v.name.includes(medium) && v.name.includes(baseSize))
    ?.id;
};


const runPersonaliserCart = async () => {
  // 1) wait for DOM so theme JS has a chance to attach listeners
  if (document.readyState === 'loading') {
    await new Promise(resolve => document.addEventListener('DOMContentLoaded', resolve, { once: true }));
  }

  const params = new URLSearchParams(window.location.search);
  const fileToken = params.get("file-token");
  const medium = params.get("variant-medium");
  const baseSize = params.get("variant-base-size");
  const thumbnailUrl = params.get("thumbnail-url");
  const editUrl = params.get("edit-url");

  if (!fileToken || !medium || !baseSize) {
    return;
  }

  const variantId = getPersonaliserVariantId(medium, baseSize);
  if (!variantId) {
    console.error("No matching variant for ", medium, baseSize);
    return;
  }

  await personaliserAddToCart(variantId, {
    _fileToken: fileToken,
    _thumbnailUrl: thumbnailUrl,
    _editUrl: editUrl
  });

  const productEl = document.querySelector('[data-section-type="product"]')
  const event = new CustomEvent('product:added', {
    bubbles: true,
    detail: {
      quantity: 1,
      variant: { id: variantId }
    }
  });
  productEl.dispatchEvent(event);

  const url = window.location.origin + window.location.pathname;
  window.history.replaceState({}, document.title, url);
};

runPersonaliserCart().catch(console.error);
